export default __webpack_public_path__ + "static/media/front_icon.72646fee.png";